module.exports = __webpack_public_path__ + "static/media/124.82cfc13e.webp";